/* eslint-disable max-lines */
/* eslint-disable max-statements */
(() => {
  let structure = '';

  const deliveryMethodText = $('.ph-orderhistory__deliverymethod').text(),
      deliveryPrefText = $('.ph-orderhistory__deliverypref').text(),
      singleShipText = $('.ph-orderhistory__singleship').text(),
      shipToText = $('.ph-orderhistory__shiptonumber').text(),
      multipleShipText = $('.ph-orderhistory__multipleship').text(),
      myOrdersAppDataClass = 'ph-myApprovalOrders-data',
      getOrderApprovalHistoryUrl = 'ph-getOrderApprovalHistoryUrl',
      contactNumber = $('.ph-orderhistory__contactnumber').text(),
      paymentMethod = $('.ph-orderhistory__paymentmethod').text(),
      orderPlacedby = $('.ph-orderhistory__orderplacedby').text(),
      deliveryInstruction = $('.ph-orderhistory__deliveryinstruction').text(),
      ponumberlabel = $('.ponumberlabel').text(),
      shippingAddText = $('.ph-orderhistory__shippingaddress').text(),
      billingAddText = $('.ph-orderhistory__billingaddress').text(),
      payeeAddText = $('.ph-orderhistory__payeeaddress').text(),
      commentsText = $('.ph-text-comments').text(),
      approverTitleText = $('.ph-text-approvertitle').text(),
      savingsText = $('.ph-orderhistory__savings').text(),
      deliveryText = $('.ph-orderhistory__delivery').text(),
      showCost = $('.ph-showadditionalcost').text(),
      taxText = $('.ph-orderhistory__tax').text(),
      totalPcmsText = $('.ph-orderhistory__total').text(),
      reorderText = $('.ph-orderhistory__reorder').html(),
      approveButtonText = $('.ph-text-approvebtn').text(),
      rejectTitleText = $('.ph-text-rejecttitle').text(),
      sortingText = 'ph-sortingtext_';

  const allAddresses = (add) => {
    structure = `${structure} <div>
                        <ul class="ph-pl-0">
                        <li> ${add.companyName} </li>`;

    if (add.companyName2 !== null) {
      structure = `${structure} <li> ${add.companyName2}</li>`;
    }

    structure = `${structure} <li> ${add.line1} </li>`;

    if (add.europeanAddressFormat === 'true') {
      structure = `${structure} <li> ${add.postalCode}  ${add.town} </li>`;
    } else {
      structure = `${structure} <li> ${add.town},`;

      if ($('.showRegion').html() === 'true' && add.region && add.region.isocodeShort) {
        structure = `${structure} ${add.region.isocodeShort}`;
      }

      structure = `${structure} ${add.postalCode}</li>`;
    }

    structure = `${structure}</ul>
                 </div></div>
                 <div class="ph-col-6 ph-p-0 ph-float-left">`;
  };

  const personalDeliveryDetails = (personalInfo, paymentInfo) => {
    structure = `${structure}
                 <div class="ph-col-12 ph-p-0 ph-float-left">
                   <div class="ph-col-6 ph-float-left">
                     <p class="strong">${personalInfo}</p>
                   </div>
                   <div class="ph-col-6 ph-float-left">
                     <p>${paymentInfo}</p>
                   </div>
                 </div>`;
  };

  const paymentMethodValue = (data) => {
    let paymenttypeValue = '';

    if (data.paymentType && data.paymentType.code) {
      if (data.paymentType.code === 'ACCOUNT') {
        paymenttypeValue = $('.ph-paymenttypeAccount').text();
      } else if (data.paymentType.code === 'FINANCE') {
        paymenttypeValue = $('.ph-paymenttypeFinance').text();
      } else {
        paymenttypeValue = $('.ph-paymenttypeCard').text();
      }

      personalDeliveryDetails(paymentMethod, paymenttypeValue);
    }
  };

  const deliveryInformation = (data) => {
    if (data.deliveryPhone !== '' && data.deliveryPhone !== null) {
      personalDeliveryDetails(contactNumber, data.deliveryPhone);
    }

    paymentMethodValue(data);

    if (data.deliveryAttention !== '' && data.deliveryAttention !== null) {
      personalDeliveryDetails(deliveryInstruction, data.deliveryAttention);
    }

    if (data.uid !== '' && data.uid !== null) {
      personalDeliveryDetails(orderPlacedby, data.b2bCustomerData.uid);
    }
  };

  const ponumber = (data) => {
    if (data.purchaseOrderNumber !== '') {
      structure = `${structure} <div class="ph-col-12 ph-p-0 ph-float-left">
                   <div class="ph-col-6  ph-ponumber ph-float-left strong"><p class="ph-ponumber-label">${ponumberlabel}</p></div>
                   <div class="ph-col-6  ph-ponumber ph-float-left"><p class="ph-ponumber-value ph-wordBreak">${data.purchaseOrderNumber}</p></div>
                   </div>`;
    }
  };

  const addressDetails = (address, addressDelivery) => {
    structure = `${structure}
                 <div class="ph-col-12 ph-float-left"> 
                   <span class="strong"> ${address}</span>
                   <p> ${addressDelivery}</p>
                 </div>`;
  };

  const addressType = (addType, dataAddType) => {
    structure = `${structure} 
                 <div class="ph-col-md-6 ph-col-sm-12 ph-float-left">
                   <span class="strong"> ${addType} </span>`;

    allAddresses(dataAddType);

    structure = `${structure} </div>`;
  };

  const hhsPage = (data) => {
    structure = `${structure} <div class="ph-orderhistory_panelcollapse ph-collapse">
                 <div class="ph-mediadiv ph-float-right ph-col-lg-2 ph-col-md-2 ph-col-sm-3">
                   <span class="ph-printicon-image ph-print-order"></span>
                 </div>
                 <div class="ph-orderhistory__panelbody ph-orderhistory_border ph-col-12 ph-float-left">
                 <div class="ph-orderhistory__paymentdetails ph-orderhistory_border ph-orderhistory_fontstyle ph-col-12 ph-px-0 ph-float-left">`;

    ponumber(data);

    deliveryInformation(data);
    structure = `${structure} </div>
                 <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-px-0 ph-float-left">`;

    if (data.deliveryAddress !== null) {
      addressType(shippingAddText, data.deliveryAddress);
    }

    structure = `${structure} <div class="ph-col-md-6 ph-col-sm-12 ph-p-0 ph-float-right">`;

    if (data.deliveryMode !== null) {
      addressDetails(deliveryMethodText, data.deliveryMode.name);
    }

    if (data.isCompleteDelivery !== null) {
      structure = `${structure}
                   <div class="ph-col-12 ph-float-left"> 
                   <span class="strong"> ${deliveryPrefText}</span>`;

      if (data.isCompleteDelivery) {
        structure = `${structure} <p>${singleShipText}</p>`;
      } else {
        structure = `${structure} <p>${multipleShipText}</p>`;
      }

      structure = `${structure} </div>`;
    }

    if (data.deliveryAddress && data.deliveryAddress.customerNumber) {
      addressDetails(shipToText, data.deliveryAddress.customerNumber);
    }

    structure = `${structure}
                 </div></div>
                 <div class="ph-col-12 ph-p-0 ph-float-left"></div>
                 <div class="ph-lazyloaded-invoices"></div>`;
  };

  const deliveryDetails = (data) => {
    structure = `${structure} </div><div class="ph-col-6 ph-p-0 ph-float-left">`;

    if (data.deliveryMode !== null && data.deliveryMode.name !== null) {
      addressDetails(deliveryMethodText, data.deliveryMode.name);
    }

    structure = `${structure}
                <div class="ph-col-12 ph-float-left"> 
                <span class="strong">${deliveryPrefText}</span>`;

    if (data.isCompleteDelivery !== null && data.isCompleteDelivery === true) {
      structure = `${structure} <p>${singleShipText}</p>`;
    } else {
      structure = `${structure} <p>${multipleShipText}</p>`;
    }

    structure = `${structure} </div>`;

    if ((data.deliveryAddress !== null && data.deliveryAddress !== '') &&
        (data.deliveryAddress.customerNumber !== null && data.deliveryAddress.customerNumber !== '')) {
      addressDetails(shipToText, data.deliveryAddress.customerNumber);
    }
  };

  const pcms = (data) => {
    structure = `${structure}
                 <div class="ph-orderhistory_panelcollapse ph-collapse">
                   <div class="ph-mediadiv ph-float-right ph-col-lg-2 ph-col-md-2 ph-col-sm-3">
                     <span class="ph-printicon-image ph-print-order"></span>
                   </div>
                   <div class="ph-orderhistory__panelbody ph-orderhistory_border ph-col-12 ph-float-left">
                   <div class="ph-orderhistory_details ph-orderhistory_border ph-mb-1 ph-col-12 ph-p-0 ph-float-left">`;

    ponumber(data);

    deliveryInformation(data);

    structure = `${structure} 
                </div>
                <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-p-0 ph-float-left">
                <div class="ph-col-6 ph-p-0 ph-float-left">`;

    if ((data.status !== '') && (data.paymentAddress !== null && data.paymentType.code === 'ACCOUNT')) {
      addressType(billingAddText, data.paymentAddress);
    }

    if (data.deliveryAddress !== null) {
      addressType(shippingAddText, data.deliveryAddress);
    }

    if ((data.status !== '' && String(data.isSparePartOrder) !== 'true') &&
      (data.payerAddress !== null && data.paymentType.code === 'ACCOUNT')) {
      addressType(payeeAddText, data.payerAddress);
    }

    structure = `${structure} </div>
                 <div class="ph-col-6 ph-p-0 ph-float-left">`;

    deliveryDetails(data);

    structure = `${structure} </div></div><div class="ph-lazyloaded-invoices hidden"></div>`;
  };

  const additionalCost = (data) => {
    if (showCost === 'true') {
      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
                   <span class="ph-float-left ph-savings"> ${savingsText} </span>
                   <span  class="ph-float-right"> ${data.totalPromotionDiscount.formattedValue} </span>
                   </div>`;
    } else if (data.totalDiscounts.value > 0) {
      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
                   <span class="ph-float-left ph-savings">${savingsText} </span>
                   <span class="ph-float-right"> ${data.totalDiscounts.formattedValue}</span>
                   </div>`;
    }

    if (showCost === 'true' && data.deliveryMode.deliveryCost !== '') {
      const showAdditionalCost = $('.ph-showadditionalcost').attr('priceData');

      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
                   <span class="ph-float-left">  ${deliveryText} </span>`;

      if (data.deliveryMode.deliveryCost.value >= 0) {
        structure = `${structure} <span class="ph-float-right"> ${data.deliveryMode.deliveryCost.formattedValue} </span>`;
      } else {
        structure = `${structure} <span class="ph-float-right"> ${showAdditionalCost} </span>`;
      }

      structure = `${structure} </div>`;
    }
  };

  const pcmshhss = (data) => {
    structure = `${structure}
                 <div class="ph-orderhistory_total ph-orderhistory_border ph-mt-1 ph-col-12 ph-p-0 ph-float-left">
                 <div class="ph-item_container ph-m-0 ph-pt-2">`;
    additionalCost(data);

    if (data.net === true) {
      structure = `${structure} 
                   <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
                     <span class="ph-float-left">  ${taxText} </span>
                     <span  class="ph-float-right">${data.totalTax.formattedValue} </span>
                   </div>
                   <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
                     <span class="ph-float-left ph-total"> ${totalPcmsText} </span>
                     <span  class="ph-float-right ph-font-weight-bold ph-total">${data.totalPriceWithTax.formattedValue} </span>
                   </div>`;
    } else {
      structure = `${structure} 
                   <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
                     <span class="ph-float-left ph-total">${totalPcmsText} </span>
                     <span  class="ph-float-right ph-font-weight-bold ph-total">${data.totalPrice.formattedValue}</span>
                   </div>`;
    }

    structure = `${structure} </div>`;
  };

  const sparePart = (data) => {
    let displayOrderId = data.code;

    if (data.sapOrderId && data.sapOrderId !== data.code) {
      displayOrderId = data.sapOrderId;

      if ($('.ph-ishhs').html() === 'true') {
        displayOrderId = `${displayOrderId} (${data.code})`;
      }
    } else if (String(data.isSparePartOrder) === 'true' && data.sapOrderId === null) {
      displayOrderId = $('.ph-orderhistory__nullspsorderid').html();
    }

    structure = `${structure} <div data-orderid=${data.code} class= "accordion-toggle ph-orderhistory_title
                 ph-col-6 ph-col-md-4 ph-float-left" data-toggle="collapse"
                 data-parent="#accordion" aria-expanded="false" data-isSparePartOrder=${data.isSparePartOrder}>${displayOrderId}</div>`;

    if (data.purchaseOrderNumber !== '' && data.purchaseOrderNumber !== null) {
      structure = `${structure} <div class="ph-col-6 ph-col-md-8 ph-ponumber ph-float-left ph-d-flex">
                                 <span class="ph-ponumber-label">${ponumberlabel}</span>
                                 <span title=${data.purchaseOrderNumber} class="ph-ponumber-value ph-text-truncate">${data.purchaseOrderNumber}</span>
                                </div>`;
    }
  };

  const deliveryStatusPart = (data) => {
    let deliveryStatusStructure = '';

    if ((data.deliveryStatus === 'SHIPPED' || data.deliveryStatus === 'INVOICED') && data.shipmentDate) {
      deliveryStatusStructure = `${ACC.orderHistory.shippedOnDetails(data.shipmentDate)}`;
    } else if ((data.entryNumber === data.deliveryItemsQuantity) && data.orderCode === data.confirmationNumber && data.estDelDate) {
      deliveryStatusStructure = `${ACC.orderHistory.estDeliveryDetails(data.estDelDate)}`;
    }

    return deliveryStatusStructure;
  };

  const productDetails = (data) => {
    let prodlistStruc = '',
        lumifyAnchorTag = '';
    const approvalQty = $('.ph-orderhistory__qty').html();

    prodlistStruc = `${prodlistStruc} <ul class="ph-m-0">
    <li class="ph-orderhistory_productlist ph-float-left ph-p-0 ph-m-0 ph-col-12 ph-mt-1">
    <div class="ph-float-left ph-orderhistory_prodimg ph-pr-1">`;

    if (data.product.isLumifyWarranty !== '' && data.product.isLumifyWarranty !== null) {
      lumifyAnchorTag = `<a href=${data.product.url}>`;
    }

    prodlistStruc = `${prodlistStruc} ${lumifyAnchorTag}`;

    if (data.product.imageURL === null) {
      const noImage = `${ACC.config.commonResourcePath}/philipsUI/src/images/no-image-130x130.gif`;

      prodlistStruc = `${prodlistStruc} <div class="ph-p-0">
      <img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage ph-orderhistory__lazyimage" src=${noImage} class="thumb"/>
      </div>`;
    } else {
      prodlistStruc = `${prodlistStruc} <div class="ph-p-0">
      <img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage ph-orderhistory__lazyimage" src=${data.product.imageURL} class="thumb"/>
      </div>`;
    }


    prodlistStruc = `${prodlistStruc} </a>
    </div>
    <div class="prod_info ph-float-left ph-pr-0 ph-orderhistory_prodinfo">
    <a class="ph-orderhistory_prodname ph-float-left ph-col-md-8 ph-col-sm-12 ph-p-0" `;

    prodlistStruc = `${prodlistStruc} ${ACC.orderHistory.productDetailsCondition(data)}`;

    prodlistStruc = `${prodlistStruc} </a>
    <div class="ph-float-left ph-orderhistory_prodprice ph-orderhistory_fontstyle ph-orderhistory_productname ph-col-md-5 ph-col-sm-12 ph-p-0">
    <div class="ph-orderhistory_qty ph-col-6 ph-float-left ph-p-0">
    <span class="ph-orderhistory_qtytext" data-qtypurchased="${data.quantity}" >
      ${approvalQty} : </span>
    <span>${data.quantity}</span>`;

    if ($('.ph-displayuom').html() === 'true') {
      prodlistStruc = `${prodlistStruc} <span>${data.product.unitOfMeasure}</span>`;
    }

    prodlistStruc = `${prodlistStruc} </span>
    </div>
    <div class="ph-orderhistory_price ph-col-6 ph-float-left ph-p-0">
    <span>${data.totalPrice.formattedValue}</span>
    </div>
    </div>
    </div>
    <div class="ph-identifystatusestd-${String(data.deliveryStatus)} ph-col-12 ph-float-left ph-m-0 ph-p-0 ph-lazyloadestdate"
      id="lazyloadestdate ${data.orderCode}_${data.entryNumber}"></div>`;

    prodlistStruc = `${prodlistStruc} ${deliveryStatusPart(data)}`;

    prodlistStruc = `${prodlistStruc} </li></ul>`;

    return `${prodlistStruc}`;
  };

  const orderHistoryDetailsPart = (data, trackingView) => {
    let productionView = '';

    productionView = `${productionView} <div class="ph-orderhistory_tobeshippedproduct ph-col-12 ph-p-0 ph-mb-1 ph-float-left">`;

    if ($('.ph-ishhs').html() === 'true') {
      if (trackingView !== '') {
        productionView = `${productionView} ${trackingView}`;
      }

      productionView = `${productionView} <div data-productcode=${data.product.code}
      class="ph-col-12 ph-float-left ph-p-0 ph-lazyload-deliveryitemlist" id=lazyloadpackinglist${data.orderCode}_${data.entryNumber}></div>`;
    } else if (data.deliveryStatus === 'SHIPPED' || data.deliveryStatus === 'INVOICED') {
      productionView = `${productionView} <span class="hidden shipmentcarriername">`;

      if (String(data.carrierName) !== 'null' && String(data.carrierName) !== '') {
        productionView = `${productionView} ${data.carrierName}`;
      }

      productionView = `${productionView} </span>
      <span class=" ph-lazyload-tracking" id=lazyloadpackinglist${data.orderCode}_${data.entryNumber}></span>`;
    }

    productionView = `${productionView} ${productDetails(data)}`;
    productionView = `${productionView} </div>`;


    return `${productionView}`;
  };

  const prices = (data) => {
    const {statusDisplay} = data;
    let status = statusDisplay.charAt(0).toUpperCase() + statusDisplay.slice(1).toLowerCase();

    const date = new Date(data.created);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    const stringDate = date.toLocaleDateString('en-US', options);

    structure = `${structure}
                 <div class="ph-col-12 ph-orderhistory_titleinfo ph-p-0 ph-float-left">
                 <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory_fontstyle">${stringDate}</span>
                 <span class="ph-col-3 ph-pr-1 ph-orderhistory_tolprice ph-orderhistory_fontstyle ph-float-left">`;

    if (data.net === true) {
      structure = `${structure} <span>${data.totalPriceWithTax.formattedValue}</span>`;
    } else {
      structure = `${structure} <span>${data.totalPrice.formattedValue}</span>`;
    }

    if (data.status.code && $.trim($(`.${sortingText}${data.status.code}`).html()) !== '') {
      status = $.trim($(`.${sortingText}${data.status.code}`).html());
    }

    if (data.statusCode) {
      status = data.statusCode;
    }

    structure = `${structure}
                 </span>
                 <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory-created">
                   <span class="ph-orderhistory-dot ph-float-left ph-${data.status.code}"></span>
                   <p class="ph-orderhistory__status ph-orderhistory_fontstyle ph-mb-0">${status}</p>
                 </span></div></div>`;
  };

  const approverComments = (data) => {
    const {statusDisplay} = data;

    let status = statusDisplay.charAt(0).toUpperCase() + statusDisplay.slice(1).toLowerCase();

    if (data.b2bPermissionResult[0].status.code && $.trim($(`.${sortingText}${data.b2bPermissionResult[0].status.code}`).html()) !== '') {
      status = $.trim($(`.${sortingText}${data.b2bPermissionResult[0].status.code}`).html());
    }

    if (data.b2bPermissionResult.length > 0) {
      structure = `${structure}
                 <div class="ph-orderhistory_approver ph-orderhistory_border ph-mt-1 ph-col-12 ph-px-0 ph-float-left">
                 <div class="ph-col-12 ph-p-0 ph-float-left">
                                 <div class="ph-col-md-6 ph-col-sm-12 ph-float-left">
                 <p class="strong"> ${approverTitleText} </p>
                                 <p> ${data.b2bPermissionResult[0].approver}</p></div>
                                 <div class="ph-col-md-6 ph-col-sm-12 ph-float-left ph-mt-3">
                 <span class="ph-pr-0 ph-float-left ph-orderhistory-created">
                                 <span class="ph-orderhistory-dot ph-${data.b2bPermissionResult[0].statusDisplay.toUpperCase()} ph-float-left">
                 </span>
                                 <p class="ph-orderhistory__status ph-orderhistory_fontstyle ph-mb-0">${status}</p>
                 </span></div>`;

      if (data.b2bPermissionResult[0].statusDisplay !== 'Approved' && data.b2bPermissionResult[0].statusDisplay !== 'Rejected') {
        structure = `${structure}
                 <div class="ph-col-md-12 ph-col-sm-12 ph-float-left">
                 <p class="strong">${commentsText}</p>
                 <input type="text" name="comments" id="comments" class="ph-orderhistory__comments ph-col-12"
                   ${data.b2bPermissionResult[0].approverNotes}></div>`;
      } else {
        structure = `${structure}
                  <div class="ph-col-md-12 ph-col-sm-12 ph-float-left">
                  <p class="strong">${commentsText}</p>
                  <input type="text" name="comments" id="comments" class="ph-orderhistory__comments ph-col-12" disabled="true"
                  value=${data.b2bPermissionResult[0].approverNotes}></div>`;
      }

      structure = `${structure} </div></div>`;
    }
  };

  const getButtons = (data, reorderDecision) => {
    let reorderButton = '';

    if (reorderDecision[data.b2bOrderData.code] === true) {
      reorderButton = `<button class="approverDecisionButton ph-mr-1 ph-ml-0 ph-mb-lg-0 ph-orderhistory_reorder re-order ph-col-4 ph-float-left"
      type="button" id="approverDecisionReorder" data-decision="REORDER">${reorderText}</button>`;
    }

    if (data.approvalDecisionRequired) {
      const csrfToken = $('input[name ="CSRFToken"]').val();
      /* eslint-disable xss/no-mixed-html */
      let csrfAndWorkflowcodeView = '<input id="approverSelectedDecision" name="approverSelectedDecision" type="hidden" value="">';

      /* eslint-enable xss/no-mixed-html */
      if (data.workflowActionModelCode) {
        csrfAndWorkflowcodeView = `${csrfAndWorkflowcodeView}<input id="workFlowActionCode" name="workFlowActionCode"
          type="hidden" value=${data.workflowActionModelCode}>`;
      }

      if (csrfToken) {
        csrfAndWorkflowcodeView = `${csrfAndWorkflowcodeView}<input type="hidden" name="CSRFToken" value="${csrfToken}">`;
      }

      structure = `${structure} 
                   <div class="ph-orderhistory_buttons ph-orderhistory_border ph-col-12 ph-float-left ph-pl-1">
                   ${csrfAndWorkflowcodeView}
                   <input type="hidden" name="orderCode" path="orderCode" value="${data.b2bOrderData.code}" />
<button class="approverDecisionButton ph-mr-1 ph-mb-1 ph-mb-lg-0 positive ph-positive ph-orderhistory_approve re-order ph-mt-0 ph-col-4 ph-float-left"
      type="button" id="approverDecisionApprove" data-decision="APPROVE">
      ${approveButtonText}</button>
      <button class="approverDecisionButton ph-mr-1 ph-mb-1 ph-mb-lg-0 ph-ml-0 ph-orderhistory_reject re-order ph-col-4 ph-float-left"
      type="button" id="approverDecisionReject" data-decision="REJECT">
      ${rejectTitleText} </button>
        ${reorderButton}
       </div>`;
    } else if (reorderButton !== '') {
      structure = `${structure}
                   <div class="ph-orderhistory_buttons ph-orderhistory_border ph-col-12 ph-float-left ph-pl-1">
                   <input type="hidden" name="orderCode" path="orderCode" value="${data.b2bOrderData.code}" />
                   ${reorderButton}
                   </div>`;
    }

    structure = `${structure}</div></div></div></form>`;
  };

  const productIterationPart = (orderApprovalDetailsMapDataEntries) => {
    let trackingView = '',
        currentTrackUrl = '',
        deliveryStatusValue = '';

    const shippedlabelmsg = $('.shippedlabelmsg').text().trim(),
        shipmenttrackmsg = $('.shipmenttrackmsg').text().trim(),
        groupOrderProducts = {};

    for (const entriesorderdetails in orderApprovalDetailsMapDataEntries) {
      if (orderApprovalDetailsMapDataEntries !== '') {
        const productEntryData = orderApprovalDetailsMapDataEntries[entriesorderdetails];

        if (productEntryData.orderEntryTrackingURLDetails.length > 0 &&
          String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== 'undefined' &&
          String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== '') {
          currentTrackUrl = productEntryData.orderEntryTrackingURLDetails[0].trackingURL;

          if (currentTrackUrl !== '') {
            trackingView = `<span class="ph-orderhistory_fontstyle ph-orderHistory__shippedLabelClass ph-col-12 ph-float-left ph-px-0 ph-py-1">
            ${shippedlabelmsg}(<a href=${currentTrackUrl} target="_blank" class="confirmation-link">
            ${shipmenttrackmsg}</a>) </span>`;
          }
        }

        deliveryStatusValue = ACC.orderHistory.getDeliveryStatusValue(productEntryData);

        if (!groupOrderProducts[deliveryStatusValue]) {
          groupOrderProducts[deliveryStatusValue] = '';
        }

        groupOrderProducts[deliveryStatusValue] = `${groupOrderProducts[deliveryStatusValue]}
        ${orderHistoryDetailsPart(productEntryData, trackingView)}`;
      }
    }

    structure = `${structure} ${ACC.orderHistory.renderGroupedOrderProducts(groupOrderProducts)}`;
  };

  const titlePart = (data) => {
    const orderApprovalDetailsMapData = data.orderApprovalDetailsMap,
        reorderButtonDecision = data.orderReorderButtonMap,
        reorderAction = $.trim($('.ph-reorderurl').html()),
        [wrapper] = document.querySelectorAll(`.${myOrdersAppDataClass}`),
        productInOrder = $('.ph-orderhistory__prodinorder').text();

    for (const orderdetails in orderApprovalDetailsMapData) {
      if (orderApprovalDetailsMapData !== '') {
        structure = '';
        structure = `<form action=${reorderAction} id="approvalDecisionForm" modelAttribute="orderApprovalDecisionForm"
           method="POST" action=${reorderAction} class="ph-orderapprovaldecision ph-printorder-list">
          <div class="ph-col-12 ph-orderhistory__container ph-mb-1 ph-float-left ph-p-0">
          <div class="ph-orderhistory_panel ph-orderhistory_paneldefault">
          <div class="ph-orderhistory_panelheading">
          <div class="ph-orderhistory_paneltitle ph-icon-arrow-down ph-orderhistory_border ph-col-12 ph-float-left">`;

        sparePart(orderApprovalDetailsMapData[orderdetails].b2bOrderData);

        prices(orderApprovalDetailsMapData[orderdetails].b2bOrderData);

        if ($('.ph-ishhs').html() === 'true') {
          hhsPage(orderApprovalDetailsMapData[orderdetails].b2bOrderData);
        } else {
          pcms(orderApprovalDetailsMapData[orderdetails].b2bOrderData);
        }

        approverComments(orderApprovalDetailsMapData[orderdetails].b2bOrderData);

        const orderApprovalDetailsMapDataEntries = orderApprovalDetailsMapData[orderdetails].b2bOrderData.entries;

        pcmshhss(orderApprovalDetailsMapData[orderdetails].b2bOrderData);
        structure = `${structure}
          </div>
          <div class="ph-orderhistory_products ph-pt-1 ph-col-12 ph-float-left">
          <h4 class="ph-col-12 ph-p-0 ph-mb-1"> ${productInOrder} (${orderApprovalDetailsMapData[orderdetails].b2bOrderData.totalItems})</h4>`;

        productIterationPart(orderApprovalDetailsMapDataEntries);

        structure = `${structure}</div>`;

        getButtons(orderApprovalDetailsMapData[orderdetails], reorderButtonDecision);

        wrapper.insertAdjacentHTML('beforeend', structure);
      }
    }
  };

  /**
   * @description Loads content.
   * @returns {void} - This returns nothing.
   * @param {json} container - Container for intersection.
   * @param {json} observer - Observer for intersection.
   * @example loadContentSmartly();
   */

  const loadContentSmartly = (container, observer) => {
    const lengthCheck = $(`.${myOrdersAppDataClass}`).find('.ph-orderhistory_panelheading').length / $('.ph-ordersshown').html(),
        numberOfPages = parseInt($('.orderApprovalNav .ph-ordersshown').attr('data-pagenumber'), 10),
        pageLength = Math.ceil(lengthCheck),
        dataInitiated = 'data-initiated',
        initiated = parseInt($(`.${getOrderApprovalHistoryUrl}`).attr(dataInitiated), 10);

    if ((initiated < pageLength && pageLength < parseInt($(`.${getOrderApprovalHistoryUrl}`).attr('data-number-of-pages'), 10)) &&
        (pageLength <= numberOfPages)) {
      $(`.${getOrderApprovalHistoryUrl}`).attr(dataInitiated, pageLength);

      $.ajax({
        url: `${ACC.config.contextPath + ACC.ordersLoader.approvalOrdersJsonUrl}?sort=${ACC.ordersLoader.currentSortingValue}&page=${pageLength}`,
        dataType: 'json',
        async: false,
        success: (data) => {
          $(`.${getOrderApprovalHistoryUrl}`).attr('data-loaded', pageLength);
          titlePart(data);
        }
      });
    } else {
      $('.ph-intersection-observer').find('.ph-load').hide();
    }

    observer.unobserve(container);
  };

  /**
   * @returns {void} - This returns nothing.
   * @example setObserver();
   */
  const setObserver = () => {
    const container = document.querySelector('.ph-intersection-observer');

    /**
     * @returns {void} - This returns nothing.
     * @example intersection()
     */
    const intersection = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.map((entry) => {
          const {isIntersecting} = entry;

          /* eslint-disable sonarjs/no-collapsible-if */
          if (isIntersecting) {
            if ($('.ph-activeApprovalCheck').attr('data-active') === 'true') {
              loadContentSmartly(container, observer);
              observer.observe(container);
            }
          }
          /* eslint-enable sonarjs/no-collapsible-if */

          /* eslint-disable array-func/no-unnecessary-this-arg */
          return true;
        }, {
          /* eslint-enable array-func/no-unnecessary-this-arg */
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    };

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      fetch(`${ACC.config.commonResourcePath}/philipsUI/src/js/vendor/intersection-observer.min.js`, () => {
        intersection();
      });
    }
  };

  /**
   * @returns {void} - This returns nothing.
   * @example sortingSelectBoxApproval()
   */
  const sortingSelectBoxApproval = () => {
    if ($(`.${myOrdersAppDataClass}`).find('.ph-ordersfilter-loader').length === 0) {
      $(`.${myOrdersAppDataClass}`).prepend(`<div class="ph-ordersfilter-loader ph-p-0 ph-m-0 ph-col-12">
      <div class="ph-loading-wrapper"><div class="ph-loadingtext">Loading...</div><div class="ph-smart-loader"></div></div></div>`);
    }

    $.ajax({
      url: ACC.ordersLoader.getOrdersAjaxUrl(),
      dataType: 'json',
      async: true,
      success: (data) => {
        $(`.${myOrdersAppDataClass}`).html('');

        $(`.${getOrderApprovalHistoryUrl}`).attr('data-initiated', 0);
        titlePart(data);
      },
      error: () => {
        $(`.${myOrdersAppDataClass}`).find('.ph-ordersfilter-loader').remove();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    const myApprovalOrdersClass = 'ph-myApprovalOrders',
        phActiveClass = 'ph-active',
        sortcodeAttribute = 'sortcode',
        sortingItemClass = 'ph-sorting__item',
        noSearchResultHidden = $('.ph-page-orders').find('.ph-freetextsearch__resultwrapper').hasClass('ph-d-none');

    /**
     * @returns {void} - This returns nothing.
     * @example callSetObserver()
     */
    const callSetObserver = () => {
      if ($('.template-pages-AccountPageTemplate .ph-myApprovalOrders-data .ph-orderhistory_paneltitle').length > 0 && noSearchResultHidden) {
        setObserver();
      }
    };

    if ($(`.${myApprovalOrdersClass}`).is(':checked')) {
      $('.ph-ERROR').not('.ph-sorting__itemcolor').remove();
      setTimeout(() => {
        sortingSelectBoxApproval();
      }, 2000);
      callSetObserver();
    }

    $(`.${myApprovalOrdersClass}`).on('change', function() {
      if ($(this).is(':checked')) {
        $('.ph-ERROR').not('.ph-sorting__itemcolor').remove();
        callSetObserver();
      }
    });

    $(document).on('click', '.ph-sorting__item', function() {
      if ($(`.${myApprovalOrdersClass}`).is(':checked')) {
        $(`.${sortingItemClass}`).removeClass(phActiveClass);
        $(this).addClass(phActiveClass);
        ACC.ordersLoader.hideSearchResult();
        ACC.ordersLoader.onSortingChanged($(this).attr(sortcodeAttribute));
        $('#ordersSortingSelect').attr(sortcodeAttribute, $(this).attr(sortcodeAttribute)).html($(this).html());
        ACC.ordersLoader.updatePageUrl();
        sortingSelectBoxApproval();
      }
    });
    window.addEventListener('popstate', (event) => {
      if ($(`.${myApprovalOrdersClass}`).is(':checked')) {
        ACC.ordersLoader.onSortingChanged(event.state.sort);
        document.querySelector(`.${sortingItemClass}`).removeClass(phActiveClass);
        $(`#sortingItem_${event.state.sort}`).addClass(phActiveClass);
        $('#ordersSortingSelect').attr(sortcodeAttribute, event.state.sort).html($(`#sortingItem_${event.state.sort}`).html());
        sortingSelectBoxApproval();
      }
    });
  });
})();
/* eslint-enable max-lines */
/* eslint-enable max-statements */
